import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Button, Spinner, Form } from "react-bootstrap";
import PageTitle from "../../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import { saveUserData, updateUserData, getUserListById } from "../../../redux/actions/UserActions";
import { getAllStateList, getAllCityStateWiseList, getMasterUsertypeList, getAllUsertypeUserList, getMasterUsertypeUserWiseList, getGeofenceList, getMasterUserUserTypeWiseList, getMasterAllUserList, getAllZoneList } from "../../../redux/actions/MasterActions";
import FormInput from "../../../Components/FormInput";
import { useNavigate, useParams } from "react-router-dom";
import { logout } from "../../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import Select from "react-dropdown-select";
import swal from 'sweetalert2';
import {getDateTimeMysqlGivenFormatYmd } from '../../../util/generalUtills'
import Preloader from "../../../Components/Preloader";
const Dashboard = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [formData, setFormData] = useState({});
  const [stateId, setStateId] = useState(null);
  const [typeId, setTypeId] = useState(null);
  const [showReporting, setShowReporting] = useState(false);
  const attendanceTypeList = [
    {
      id: "Anywhere",
      name: 'Anywhere'
    },
    {
      id: "Geofence",
      name: 'Geofence'
    }
  ]
  const attendanceTimeList = [
    {
      id: "Anytime",
      name: 'Anytime'
    },
    {
      id: "Office Time",
      name: 'Office Time'
    }
  ]
  const emplopyeeType = [
    {
      id: "Salary",
      name: 'Salary'
    },
    {
      id: "Freelancer",
      name: 'Freelancer'
    }
  ]
  const locationTypeData = [
    {
      id: "Enable",
      name: 'Enable'
    },
    {
      id: "Disable",
      name: 'Disable'
    }
  ]
  const genderData = [
    {
      id: "Male",
      name: 'Male'
    },
    {
      id: "Female",
      name: 'Female'
    },
    {
      id: "Other",
      name: 'Other'
    }
  ]

  const weeklyOffList = [
    {
      id: "Sunday",
      name: 'Sunday'
    },
    {
      id: "Monday",
      name: 'Monday'
    },
    {
      id: "Tuesday",
      name: 'Tuesday'
    },
    {
      id: "Wednesday",
      name: 'Wednesday'
    },
    {
      id: "Thursday",
      name: 'Thursday'
    },
    {
      id: "Friday",
      name: 'Friday'
    },
    {
      id: "Saturday",
      name: 'Saturday'
    }
  ]
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
    userReducer: {
      userSingleList,
      loadingUser,
      errorsUser,
      changedUserStatus,
    },
    masterReducer: {
      masterStateLists,
      masterCityStateWiseLists,
      masterUsertypeLists,
      masterUserLists,
      masterGeofenceList,
      loadingMaster,
      errorsMaster,
      masterZoneList,
    },
  } = useSelector((state) => state);

  useEffect(() =>{
    // console.log('masterCityStateWiseLists',masterCityStateWiseLists)
  },[masterCityStateWiseLists])

  useEffect(() => {
    if (auth?.token) {
      dispatch(getAllStateList(auth.token));
      dispatch(getMasterUsertypeUserWiseList(auth.token));
      dispatch(getGeofenceList(auth.token));
      dispatch(getAllZoneList(auth.token));
    }
  }, [auth?.token]);

  useEffect(() => {
    if (auth?.token && stateId) {
      dispatch(getAllCityStateWiseList(auth.token, stateId));
    }
  }, [auth?.token, stateId, dispatch]);

  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }
    if (showReporting && (!formData.reporting_id || formData.reporting_id === "")) {
      toast.error(t("Please select Reporting To"));
      setValidated(true);
      return;
    }
    setValidated(true);
    if(id){
      dispatch(updateUserData(auth?.token, formData,id));
    }
    else{
      dispatch(saveUserData(auth?.token, formData));
    }
  };

  useEffect(() => {
    if(id)
    {
      dispatch(getUserListById(auth?.token, id));
    }
  }, [auth, id]);

  useEffect(()=>{
    if(id)
    {
      if(userSingleList && Object.keys(userSingleList).length>0)
      {
        setFormData({
          state_code: userSingleList?.citiesAdminUsers?.cities_state?.state_code,
          city_id: userSingleList?.city_id,
          user_type_id: userSingleList?.user_type_id,
          reporting_id: userSingleList?.reporting_id,
          name: userSingleList?.name,
          phone: userSingleList?.phone,
          email: userSingleList?.email,
          address: userSingleList?.address,
          username: userSingleList?.username,
          attendance_type: userSingleList?.attendance_type,
          password: userSingleList?.password,
          live_location: userSingleList?.live_location,
          employee_type: userSingleList?.employee_type,
          geofence_id: userSingleList?.geofence_id,
          zone_id: userSingleList?.zone_id,
          imei: userSingleList?.imei,
          official_mail_id: userSingleList?.official_mail_id,
          attendance: userSingleList?.attendance,
          attendance_time: userSingleList?.attendance_time,
          gender: userSingleList?.gender,
          weekoff: userSingleList?.weekoff,
          travelling_allowance_per_km: userSingleList?.travelling_allowance_per_km,
          back_office_case_payment_amount: userSingleList?.back_office_case_payment_amount,
          allow_panel_login: userSingleList?.allow_panel_login || false,
        });
      }
    }
    
  },[userSingleList])


  useEffect(() => {
    if (errors && Object.keys(errors).length > 0) {
      if (errors?.status === 401) {
        dispatch(logout());
        toast.error(errors?.data?.message);
        navigate('/login');
        window.location.reload();
      }
    }
  }, [errors, dispatch, navigate]);

  useEffect(() => {
    if (errorsUser && Object.keys(errorsUser).length > 0) {
      if (errorsUser?.status === 409) {
        swal.fire({
          show: true,
          title: "Oops!",
          text: errorsUser?.data?.message,
          icon: "error",
          showConfirmButton: false,
          timer: 1500
        });
        dispatch({ type: 'RESET_DELETE_USER_STATUS' });
      } else if (errorsUser?.status === 400) {
        // Handle other status
      } else {
        dispatch({ type: 'RESET_DELETE_USER_STATUS' });
      }
    }
  }, [errorsUser, dispatch]);

  useEffect(() => {
    if (changedUserStatus?.success) {
      swal.fire({
        show: true,
        title: "Well done!",
        text: changedUserStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_USER_STATUS' });
      navigate('/Active-Users');
    }
  }, [changedUserStatus, dispatch, navigate]);

  // Reset formData and errorsUser when the component mounts
  useEffect(() => {
    setFormData({});
    dispatch({ type: 'RESET_DELETE_USER_STATUS' });
  }, [dispatch]);

  const inputHandler = (e) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const checkboxHandler = (e) => {
    const { checked, name } = e.target;
    setFormData({ ...formData, [name]: checked });
  };

  const inputHandlerCaps = (e) => {
    const { value, name } = e.target;
    const processedValue = value.replace(/\s+/g, '').toUpperCase(); // Remove spaces and convert to uppercase
    setFormData({ ...formData, [name]: processedValue });
  };

  const selectMobileHandler = (e) => {
    const { value, name } = e.target;
    if (/^\d{0,10}$/.test(value)) {
      setFormData(prevFormData => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };


  const selectUsernameHandler = (e) => {
    const { value, name } = e.target;
    if (/^[a-z0-9.]{0,30}$/.test(value)) {
      setFormData(prevFormData => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };

  
  

  const selectHandler2 = (selectedData, name) => {
    // const selectedId = selectedData[0]?.state_code;

    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: selectedData
    }));
    
  };

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errorsUser?.data?.vehicle_model ? 'red' : base.borderColor,
      '&:hover': {
        borderColor: errorsUser?.data?.vehicle_model ? 'red' : base.borderColor,
      }
    }),
  };

  const onDateChange = (name,value) => {
    if (value) {
      setFormData({ ...formData, [name]: getDateTimeMysqlGivenFormatYmd(value) });
    }
  };

  useEffect(() => {
      document.title = `Add New Users :: ${auth?.generalSettings?.title}`;
    }, []);

  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: t("User"), path: "/Active-Users" },
          { label: (userSingleList && Object.keys(userSingleList).length>0) ? t("Update User") : t("Add User"), path: "/Add-User", active: true },
        ]}
        title={(userSingleList && Object.keys(userSingleList).length>0) ? t("Update User") : t("Add User")}
      />
      <Row>
        <Col lg={12}>
          <Card>
            <Card.Body>
              {errors?.data?.message && (
                <div className="alert alert-danger">
                  {errors.data.message}
                </div>
              )}
              <Row>
                <Col lg={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("State")}</Form.Label>
                    <Select
                      options={masterStateLists}
                      values={masterStateLists?.filter(state => state.state_code === formData.state_code)}
                      name="state_code"
                      labelField={"state_name"}
                      valueField={"state_code"}
                      searchBy={"state_name"}
                      loading={loadingMaster}
                      onChange={(selectedData) => {
                        selectHandler2(selectedData[0]?.state_code, "state_code")
                        setStateId(selectedData[0]?.state_code);
                      }}
                      styles={customSelectStyles}
                    />
                    
                    {errorsUser?.data?.state_code && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{errorsUser?.data?.state_code}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col lg={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("City")}</Form.Label>
                    <Select
                      options={masterCityStateWiseLists}
                      values={masterCityStateWiseLists?.filter(city => city.city_code === formData.city_id)}
                      name="city_id"
                      labelField={"city_name"}
                      valueField={"city_code"}
                      searchBy={"city_name"}
                      loading={loadingMaster}
                      onChange={(selectedData) => {
                        selectHandler2(selectedData[0]?.city_code, "city_id")
                      }}
                      styles={customSelectStyles}
                    />
                    
                    {errorsUser?.data?.city_id && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{errorsUser?.data?.city_id}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col lg={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Zone")}</Form.Label>
                    <Select
                      options={masterZoneList}
                      values={masterZoneList?.filter(zone => zone.id === formData.zone_id)}
                      name="zone_id"
                      labelField={"zone_name"}
                      valueField={"id"}
                      searchBy={"zone_name"}
                      loading={loadingMaster}
                      onChange={(selectedData) => {
                        selectHandler2(selectedData[0]?.id, "zone_id")
                      }}
                      styles={customSelectStyles}
                    />
                    
                    {errorsUser?.data?.zone_id && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{errorsUser?.data?.zone_id}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col lg={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Usertype")}</Form.Label>
                    <Select
                      options={masterUsertypeLists?.filter(usertype => usertype.id !== 1)}
                      values={masterUsertypeLists?.filter(usertype => usertype.id === formData.user_type_id)}
                      name="user_type_id"
                      labelField={"name"}
                      valueField={"id"}
                      searchBy={"name"}
                      loading={loadingMaster}
                      onChange={(selectedData) => {
                        const selected = selectedData[0];
                        setFormData(prevFormData => ({
                          ...prevFormData,
                          'user_type_id': selected?.id
                        }));
                        if (selected?.id) {
                          const hideReporting = selected?.id === 1;
                          if (!hideReporting) {
                            dispatch(getMasterAllUserList(auth?.token, selected?.reporting ?? undefined));
                            setShowReporting(true);
                          } else {
                            setShowReporting(false);
                          }
                        } else {
                          setShowReporting(false);
                        }
                      }}
                      styles={customSelectStyles}
                    />
                    
                    {errorsUser?.data?.user_type_id && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{errorsUser?.data?.user_type_id}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>

                {showReporting && (
                  <Col lg={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("Reporting To")}</Form.Label>
                      <Select
                        options={masterUserLists.map(user => ({
                          ...user,
                          label: `${user.name} | ${user.adminUserType?.name} | ${user.citiesAdminUsers?.city_name} | ${user.citiesAdminUsers?.cities_state?.state_name}`  // Combine name and company name in the label
                        }))}
                        values={masterUserLists?.filter(usertype_user => usertype_user.id === formData.reporting_id)}
                        name="reporting_id"
                        labelField="label"  // Use the combined label
                        valueField="id"
                        searchBy={"label"}
                        onChange={(selectedData) => {
                          setFormData(prevFormData => ({
                            ...prevFormData,
                            "reporting_id": selectedData[0]?.id
                          }));
                        }}
                        styles={customSelectStyles}
                      />
                      {errorsUser?.data?.reporting_id && (
                        <div className="invalid-feedback d-block">
                          <p className="text-danger">{errorsUser?.data?.reporting_id}</p>
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                )}

                <Col lg={3}>
                  <FormInput
                    label={t("Name")}
                    type="text"
                    errors={errorsUser?.data}
                    value={formData.name}
                    name="name"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Gender")}</Form.Label>
                    <Select
                      options={genderData}
                      values={genderData?.filter(data => data.id === formData.gender)}
                      name="gender"
                      labelField={"name"}
                      valueField={"id"}
                      searchBy={"name"}
                      loading={loadingMaster}
                      onChange={(selectedData) => {
                        selectHandler2(selectedData[0]?.id, "gender")
                      }}
                      styles={customSelectStyles}
                    />
                    
                    {errorsUser?.data?.gender && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{errorsUser?.data?.gender}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col lg={3}>
                  <FormInput
                    label={t("Mobile Number")}
                    type="text"
                    errors={errorsUser?.data}
                    value={formData.phone}
                    name="phone"
                    onChange={selectMobileHandler}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={3}>
                  <FormInput
                    label={t("Email")}
                    type="text"
                    errors={errorsUser?.data}
                    value={formData.email}
                    name="email"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={3}>
                  <FormInput
                    label={t("Address")}
                    type="text"
                    errors={errorsUser?.data}
                    value={formData.address}
                    name="address"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>

                {(!id) && (
                  <>
                    <Col lg={3}>
                      <FormInput
                        label={t("Username")}
                        type="text"
                        errors={errorsUser?.data}
                        value={formData.username}
                        name="username"
                        onChange={selectUsernameHandler}
                        containerClass={"mb-3"}
                      />
                    </Col>
                  </>
                )}

                {(!id) && (
                  <>
                    <Col lg={3}>
                      <FormInput
                        label={t("Password")}
                        type="text"
                        errors={errorsUser?.data}
                        value={formData.password}
                        name="password"
                        onChange={inputHandler}
                        containerClass={"mb-3"}
                      />
                    </Col>
                  </>
                )}

                {(!id) && (
                  <>
                    <Col lg={3}>
                      <FormInput
                        label={t("Official Mail Id")}
                        type="text"
                        errors={errorsUser?.data}
                        value={formData.official_mail_id}
                        name="official_mail_id"
                        containerClass={"mb-3"}
                        onChange={inputHandler}
                      />
                    </Col>
                  </>
                )}

                <Col lg={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Attendance")}</Form.Label>
                    <Select
                      options={locationTypeData}
                      values={locationTypeData?.filter(data => data.id === formData.attendance)}
                      name="attendance"
                      labelField={"name"}
                      valueField={"id"}
                      searchBy={"name"}
                      loading={loadingMaster}
                      onChange={(selectedData) => {
                        selectHandler2(selectedData[0]?.id, "attendance")
                      }}
                      styles={customSelectStyles}
                    />
                    
                    {errorsUser?.data?.attendance && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{errorsUser?.data?.attendance}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>
                {(formData.attendance=="Enable") && (<>
                  <Col lg={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("Attendance Time")}</Form.Label>
                      <Select
                        options={attendanceTimeList}
                        values={attendanceTimeList?.filter(data => data.id === formData.attendance_time)}
                        name="attendance_time"
                        labelField={"name"}
                        valueField={"id"}
                        searchBy={"name"}
                        loading={loadingMaster}
                        onChange={(selectedData) => {
                          selectHandler2(selectedData[0]?.id, "attendance_time")
                        }}
                        styles={customSelectStyles}
                      />
                      
                      {errorsUser?.data?.attendance_time && (
                        <div className="invalid-feedback d-block">
                          <p className="text-danger">{errorsUser?.data?.attendance_time}</p>
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col lg={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("Attendance Type")}</Form.Label>
                      <Select
                        options={attendanceTypeList}
                        values={attendanceTypeList?.filter(data => data.id === formData.attendance_type)}
                        name="attendance_type"
                        labelField={"name"}
                        valueField={"id"}
                        searchBy={"name"}
                        loading={loadingMaster}
                        onChange={(selectedData) => {
                          selectHandler2(selectedData[0]?.id, "attendance_type")
                        }}
                        styles={customSelectStyles}
                      />
                      
                      {errorsUser?.data?.attendance_type && (
                        <div className="invalid-feedback d-block">
                          <p className="text-danger">{errorsUser?.data?.attendance_type}</p>
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  {(formData.attendance_type=="Geofence") && (
                    <>
                      <Col lg={3}>
                        <Form.Group className="mb-3">
                          <Form.Label>{t("Geofence")}</Form.Label>
                          <Select
                            options={masterGeofenceList}
                            values={masterGeofenceList?.filter(data => data.id === formData.geofence_id)}
                            name="geofence_id"
                            labelField={"name"}
                            valueField={"id"}
                            searchBy={"name"}
                            loading={loadingMaster}
                            onChange={(selectedData) => {
                              selectHandler2(selectedData[0]?.id, "geofence_id")
                            }}
                            styles={customSelectStyles}
                          />
                          
                          {errorsUser?.data?.geofence_id && (
                            <div className="invalid-feedback d-block">
                              <p className="text-danger">{errorsUser?.data?.geofence_id}</p>
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                    </>
                  )}
                </>)}
                

                <Col lg={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Live Location")}</Form.Label>
                    <Select
                      options={locationTypeData}
                      values={locationTypeData?.filter(data => data.id === formData.live_location)}
                      name="live_location"
                      labelField={"name"}
                      valueField={"id"}
                      searchBy={"name"}
                      loading={loadingMaster}
                      onChange={(selectedData) => {
                        selectHandler2(selectedData[0]?.id, "live_location")
                      }}
                      styles={customSelectStyles}
                    />
                    
                    {errorsUser?.data?.live_location && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{errorsUser?.data?.live_location}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col lg={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Weekly Off")}</Form.Label>
                    <Select
                      options={weeklyOffList}
                      values={weeklyOffList?.filter(data => data.id === formData.weekoff)}
                      name="weekoff"
                      labelField={"name"}
                      valueField={"id"}
                      searchBy={"name"}
                      loading={loadingMaster}
                      onChange={(selectedData) => {
                        selectHandler2(selectedData[0]?.id, "weekoff")
                      }}
                      styles={customSelectStyles}
                    />
                    
                    {errorsUser?.data?.live_location && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{errorsUser?.data?.live_location}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col lg={3}>
                  <FormInput
                    label={t("Travelling Allowance Per KM")}
                    type="text"
                    errors={errorsUser?.data}
                    value={formData.travelling_allowance_per_km}
                    name="travelling_allowance_per_km"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={3}>
                  <FormInput
                    label={t("Back Office Case Payment Amount")}
                    type="text"
                    errors={errorsUser?.data}
                    value={formData.back_office_case_payment_amount}
                    name="back_office_case_payment_amount"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Employee Type")}</Form.Label>
                    <Select
                      options={emplopyeeType}
                      values={emplopyeeType?.filter(data => data.id === formData.employee_type)}
                      name="employee_type"
                      labelField={"name"}
                      valueField={"id"}
                      searchBy={"name"}
                      loading={loadingMaster}
                      onChange={(selectedData) => {
                        selectHandler2(selectedData[0]?.id, "employee_type")
                      }}
                      styles={customSelectStyles}
                    />
                    
                    {errorsUser?.data?.employee_type && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{errorsUser?.data?.employee_type}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col lg={3}>
                  <Form.Group className="mb-0">
                    <Form.Check
                      type="checkbox"
                      id="allow_panel_login"
                      name="allow_panel_login"
                      label={t("Allow Login from portal")}
                      checked={formData.allow_panel_login || false}
                      onChange={checkboxHandler}
                      style={{ marginTop: "35px" }}
                    />
                    {errorsUser?.data?.allow_panel_login && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{errorsUser?.data?.allow_panel_login}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>

                
              </Row>

              <div className="d-flex justify-content-center">
                {loadingUser ? 
                  <Button color="primary" disabled>
                    <Spinner
                      className="spinner-border-sm me-1"
                      tag="span"
                      color="white"
                    />
                    Please wait ...
                  </Button>
                :
                  <Button type="button" onClick={handleSubmit} disabled={loadingUser}>
                    Submit
                  </Button>
                }
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {loadingMaster && (<Preloader/>)}
      {loadingUser && (<Preloader/>)}
    </>
  );
};

export default Dashboard;